// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
var useLanguage = function (_a) {
    var ballotStyle = _a.ballotStyle;
    var i18n = useTranslation().i18n;
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        var currLanguage = i18n.language;
        var electionLanguages = (_c = (_b = (_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _a === void 0 ? void 0 : _a.election_presentation) === null || _b === void 0 ? void 0 : _b.language_conf) === null || _c === void 0 ? void 0 : _c.enabled_language_codes;
        var defaultLang = (_f = (_e = (_d = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _d === void 0 ? void 0 : _d.election_presentation) === null || _e === void 0 ? void 0 : _e.language_conf) === null || _f === void 0 ? void 0 : _f.default_language_code;
        if (!electionLanguages ||
            !currLanguage ||
            electionLanguages.includes(currLanguage) ||
            !defaultLang)
            return;
        i18n.changeLanguage(defaultLang);
    }, []);
};
export default useLanguage;
